export default __webpack_public_path__ + "static/benjamin_k-d878711af9fc5dc9f936c6b910b49419.png";